module.exports = __webpack_public_path__ + "static/media/XD.30938771.jpg";